import React, {FC, PropsWithChildren} from 'react';
import DynamicAsset from 'components/DynamicAsset';
import MediaQuery from 'components/utils/MediaQuery';
import {Link} from 'gatsby';

import DragIcon from './svgs/drag.inline.svg';
import InfoIcon from './svgs/info.inline.svg';
import PopulationIcon from './svgs/population.inline.svg';
import QuestionIcon from './svgs/question.inline.svg';

import * as styles from './styles.module.scss';

const imageSrc = 'https://static.bodyspec.com/at/70/fe/70fe8f6a19a36210';
const mobileSrc = 'https://static.bodyspec.com/at/0f/ed/0feda9f0fc1061ec';

const Tutorial: FC<PropsWithChildren> = () => (
	<div className={styles.wrapper}>
		<div />
		<div className={styles.hint}>
			<DragIcon />
			<div className={styles.content}>
				<div className={styles.text}>
					<h4>Click and drag to zoom in. Double click to zoom out.</h4>
					<span>
						Charts are interactive! You can zoom in on
						any chart to get more detail.
					</span>
				</div>
				<MediaQuery desktop>
					<DynamicAsset className={styles.gif} imageSrc={imageSrc} />
				</MediaQuery>
				<MediaQuery mobile>
					<DynamicAsset className={styles.gif} imageSrc={mobileSrc} />
				</MediaQuery>
			</div>
		</div>
		<div className={styles.hint}>
			<PopulationIcon />
			<div className={styles.text}>
				<h4>This report compares your data to 300K+ BodySpec DEXA scans.</h4>
				<span>
					DEXA is the gold standard for determining body composition.
					Our proprietary population comparison data is the most comprehensive
					way to understand where you stand when it comes to your health
					metrics.
				</span>
			</div>
		</div>
		<div className={styles.hint}>
			<InfoIcon />
			<div className={styles.text}>
				<h4>Information tips are here to help.</h4>
				<span>
					Confused? Hover or click on these icons for more info.
				</span>
			</div>
		</div>
		<div className={styles.hint}>
			<QuestionIcon />
			<div className={styles.text}>
				<h4>Still have questions?</h4>
				<span>
					Join one of BodySpec's <Link to='/health-hangout'>
					Health Hangouts</Link> to get expert advice for reaching
					your fitness goals.
				</span>
			</div>
		</div>
	</div>
);

export default Tutorial;
